import React from 'react';
import { Link, NavLink, Outlet, useLocation } from 'react-router-dom';

function NavItem({ to, label, testId, end }) {
    return (
        <NavLink
            to={to}
            end={end}
            data-testid={testId}
            className={({ isActive }) =>
                `under-link text-sm transition-colors ${
                    isActive
                        ? 'is-active text-[color:var(--umber)]'
                        : 'text-[color:var(--graphite)] hover:text-[color:var(--umber)]'
                }`
            }
        >
            {label}
        </NavLink>
    );
}

export default function SiteLayout() {
    const location = useLocation();
    const isCommission = location.pathname.startsWith('/commission');
    return (
        <div className="min-h-screen flex flex-col bg-[color:var(--paper)]">
            <header className="sticky top-0 z-40 bg-[color:var(--paper)]/85 backdrop-blur supports-[backdrop-filter]:bg-[color:var(--paper)]/70 border-b border-[color:var(--border)]">
                <div className="mx-auto w-full max-w-6xl px-4 sm:px-6 lg:px-8 flex items-center justify-between h-14 sm:h-16">
                    <Link to="/" data-testid="nav-home-link" className="flex items-center gap-3 min-w-0">
                        <span className="font-display text-base sm:text-xl tracking-tight text-[color:var(--umber)] truncate">
                            Leiha Martin Art
                        </span>
                    </Link>
                    <nav className="hidden md:flex items-center gap-8">
                        <NavItem to="/" label="Home" testId="nav-home-link-secondary" end />
                        <NavItem to="/gallery" label="Gallery" testId="nav-gallery-link" />
                        <NavItem to="/commission" label="Commission" testId="nav-commission-link" />
                    </nav>
                    <div className="flex items-center gap-2 sm:gap-3">
                        <Link
                            to="/gallery"
                            data-testid="nav-gallery-cta-mobile"
                            className="md:hidden inline-flex items-center text-sm text-[color:var(--graphite)] px-2 py-2"
                        >
                            Gallery
                        </Link>
                        <Link
                            to="/commission"
                            data-testid="nav-commission-cta"
                            className="inline-flex items-center rounded-xl bg-[color:var(--umber)] text-[color:var(--paper)] hover:bg-[color:var(--ink)] transition-colors px-3 sm:px-4 py-2 text-xs sm:text-sm whitespace-nowrap"
                        >
                            <span className="hidden sm:inline">Commission a portrait</span>
                            <span className="sm:hidden">Commission</span>
                        </Link>
                    </div>
                </div>
            </header>
            <main className="flex-1">
                <Outlet />
            </main>
            {!isCommission && (
                <footer className="border-t border-[color:var(--border)] mt-12">
                    <div className="mx-auto w-full max-w-6xl px-4 sm:px-6 lg:px-8 py-10 grid grid-cols-1 md:grid-cols-3 gap-8">
                        <div>
                            <p className="font-display text-lg text-[color:var(--umber)]">Leiha Martin Art</p>
                            <p className="text-sm text-[color:var(--muted-fg)] mt-2 max-w-xs">
                                Bespoke animal portraits and fine-art prints, hand-drawn with care.
                            </p>
                        </div>
                        <div>
                            <p className="caption mb-3">Studio</p>
                            <ul className="space-y-2 text-sm">
                                <li><Link to="/gallery" className="under-link text-[color:var(--graphite)]">Gallery</Link></li>
                                <li><Link to="/commission" className="under-link text-[color:var(--graphite)]">Commission a portrait</Link></li>
                            </ul>
                        </div>
                        <div>
                            <p className="caption mb-3">Information</p>
                            <ul className="space-y-2 text-sm">
                                <li><Link to="/order-policy" data-testid="footer-order-policy-link" className="under-link text-[color:var(--graphite)]">Order &amp; commission policy</Link></li>
                                <li><Link to="/terms" data-testid="footer-terms-link" className="under-link text-[color:var(--graphite)]">Terms &amp; conditions</Link></li>
                                <li><Link to="/privacy" data-testid="footer-privacy-link" className="under-link text-[color:var(--graphite)]">Privacy policy</Link></li>
                                <li><Link to="/admin/login" data-testid="footer-admin-link" className="under-link text-[color:var(--graphite)]">Studio login</Link></li>
                            </ul>
                        </div>
                    </div>
                    <div className="border-t border-[color:var(--border)]">
                        <div className="mx-auto w-full max-w-6xl px-4 sm:px-6 lg:px-8 py-4 text-xs text-[color:var(--muted-fg)] flex flex-col sm:flex-row gap-2 justify-between">
                            <span>&copy; {new Date().getFullYear()} Leiha Martin Art</span>
                            <span>Each portrait individually drawn from your reference photograph.</span>
                        </div>
                    </div>
                </footer>
            )}
        </div>
    );
}
